import { createSelector } from 'reselect'

import { localize } from 'helpers/translator'

const quiz_delete_answer_validation_selector = questionId => createSelector(
	[ state => state.quiz ],
	quizState => {
		const question = quizState.questions.find(question => question.id === questionId)
		const valid = question.answers.length > 2
		return {
			valid,
			message: valid?null:localize('quiz_answers_minimum'),
		}
	}
)

export default quiz_delete_answer_validation_selector
